import React from 'react';
import logo from 'img/ballottrax-logo-white.png';

const BallotLogo = () => (
  <img alt={'Ballot logo'} src={logo} className="ballot-logo" />
);

export default BallotLogo;
